module.exports = __webpack_public_path__ + "img/empty-state.e088e555.png";